import "./B2BStepper.css"

import React, { useEffect, useState } from 'react';
import { Box, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material";
import { generateClassName } from './helpers';
import CustomButton from './CustomButton';
import useB2BTranslation from "./hooks/useB2BTranslation";

const B2BStepper = ({ steps, className, onSuccess, onCancel = null, currentStep = null }) => {
    const { t } = useB2BTranslation('b2b-common');
    const [activeStep, setActiveStep] = useState(currentStep ? currentStep : 0);
    const [completed, setCompleted] = useState({});

    useEffect(() => {
        if (activeStep === steps.length && onSuccess && !completed[activeStep]) {
            onSuccess();
            setCompleted(prevCompleted => ({ ...prevCompleted, [activeStep]: true }));
        }
    }, [activeStep, steps.length, onSuccess, completed]);

    const handleNext = () => {
        //console.log(steps[activeStep]);
        if (steps[activeStep].disableNext) {
            window.alert(t('You cannot proceed to the next step yet. Check instructions!'));
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <Stepper activeStep={activeStep} orientation="vertical" className={generateClassName("b2b-stepper", "", className)}>
            {steps.map((step, index) => (
                <Step key={step.label} className={`${generateClassName("b2b-stepper", "-step", className)} ${step.disableNext ? 'disable-next-step' : ''}`}>
                    <StepLabel
                        optional={
                            index === steps.length - 1 ? (
                                <Typography variant="caption">{t('Last step')}</Typography>
                            ) : null
                        }
                        className={generateClassName("b2b-stepper", "-step-label", className)}
                    >
                        {step.label}
                    </StepLabel>
                    <StepContent className={generateClassName("b2b-stepper", "-step-content", className)}>
                        <div className={generateClassName('b2b-stepper', '-step-description', className)}>{step.description}</div>
                        <Box sx={{ mb: 2 }}>
                            {step.content}
                            <div className='b2b-stepper-actions'>
                                <div className='b2b-stepper-actions-continue-back'>
                                    <CustomButton
                                        label={index === steps.length - 1 ? t('Finish') : t('Continue')}
                                        onClick={handleNext}
                                    />
                                    {index > 0 && (
                                        <CustomButton
                                            label={t('Back')}
                                            onClick={handleBack}
                                            disabled={index === 0}
                                        />
                                    )}
                                </div>
                                {onCancel && (
                                    <CustomButton
                                        label={t('Cancel')}
                                        onClick={onCancel}
                                        className='b2b-stepper-actions-cancel white_02'
                                    />
                                )}
                            </div>
                        </Box>
                    </StepContent>
                </Step>
            ))}
        </Stepper>
    );
};

export default B2BStepper;
